import React, { useEffect, useState } from 'react'
import './new-results-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import { useDispatch, useSelector } from 'react-redux';
import { UseCloudFunction } from '@/firebase-utils/firebase.utils';
import { setLeaders } from '@/state/slices/gameSlice';
import streak_bonus from '@/assets/streak-bonus.png';
import prop_bet from '@/assets/prop-bet.png';
import { getPercentages } from '../admin/matchup-list/matchup-item.component';

const NewResultsModal = ({ 
  matchups, 
  leaders 
}) => {

  const unread = useSelector(state => state.gameData.unread);
  const currentGame = useSelector(state => state.gameData.currentGame);
  const profile = useSelector(state => state.userData.profile);
  const [showNewResults, setShowNewResults] = useState(false);
  const [userData, setUserData] = useState(null);
  const [totalUnviewed, setTotalUnviewed] = useState(null);
  const [ underdogBonusTotals, setUnderdogBonusTotals ] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (!profile || !leaders || !matchups || !unread) { return; }
    const user = leaders[profile.appID];
    setUserData(user);
    if (
      unread && 
      Object.values(unread)
      .filter(u => 
        u.type === 'matchup' || 
        u.type === 'prop' || 
        u.type === 'bonus'
      ).length > 0
    ) {
      setShowNewResults(true);
    }
  }, [profile, leaders, matchups, unread])

  useEffect(() => {
    if (
      !unread || 
      !matchups ||
      Object.values(unread)
      .filter(u => 
        u.type === 'matchup' || 
        u.type === 'prop' || 
        u.type === 'bonus'
      ).length === 0
    ) { 
      return;
    } 

    // loop through unread and calculate underdog bonuses
    let underdogTotals = {};
    for (let u of Object.values(unread)) {
      if (u.type !== 'prop') { continue; }
      const matchup = matchups[u.matchId];
      if (!matchup || !matchup.picks || !matchup.picks[profile.appId]) { continue; }
      // add underdog bonus
      const pickData = matchup.picks[profile.appId];
      const percentages = getPercentages(matchup.picks, matchup);
      // console.log(percentages);
      const udBonus = pickData ?
        Math.round(
          Number(pickData.wager) *
          (1 - (.01 * percentages[`c${pickData?.pick?.substring(4)}`])))
        : 0;

      if (isNaN(udBonus)) return;
      underdogTotals[u.matchId] = udBonus;
    } 

    console.log(underdogTotals);
    setUnderdogBonusTotals(underdogTotals);

    console.log(unread);
    setTotalUnviewed(
      Object.values(unread)
        .filter(u =>
          u.type === 'matchup' ||
          u.type === 'prop' ||
          u.type === 'bonus')
        .reduce((acc, cur) => {
          let uBonus = 0;
          if (cur.type === 'prop' && cur.result === 'win' && underdogTotals[cur.matchId]) {
            uBonus = underdogTotals[cur.matchId];
          }
          return acc + cur.points + uBonus;
        }, 0
        )
    );
  }, [unread, matchups])

  async function markAsViewed() {
    setShowNewResults(false);
    const listToClear = Object.values(unread).filter(u => u.type === 'matchup' || u.type === 'prop' || u.type === 'bonus');
    console.log(listToClear)
    const res = await UseCloudFunction(
      'clearUnviewed',
      {
        'appId': profile.appId,
        'gameId': currentGame.gameId,
        'unread': listToClear,
      }
    );
    console.log(res);
  }

  return (
    <div className='new-results-modal'>
      <Modal show={showNewResults} cancel={() => setShowNewResults(false)} scrolling={'modal-scroll'} hideCloseButton={true} >

        {
          (unread && Object.values(unread).length > 0 && currentGame && currentGame.settings && matchups) &&
          <>
            <h2>New Results!</h2>
            {
              Object.values(unread)
              .filter(u => 
                u.type === 'matchup' || 
                u.type === 'prop' || 
                u.type === 'bonus'
              )
              .sort((a, b) => a.matchId > b.matchId ? 1 : -1)
              .map(un => {
                if (un.type === 'bonus') {
                  return (
                    <div key={un.matchId} className='result-box bonus'>
                      <img src={streak_bonus} />
                      <div className='game-results'>
                        <div className='title'>Streak Bonus!</div>
                        <div className='meta'>{currentGame.settings.streakCount} in a Row</div>
                        <div className={`result-pts win`}>{`+${un.points}`}</div>
                      </div>
                    </div>
                  )
                }
                const matchup = matchups[un.matchId];
                console.log(matchup);
                const winner = matchup.winner;
                const loser = winner === 'comp1' ? 'comp2' : 'comp1';
                return (
                  <div key={un.matchId} className={`result-box match ${un.result}`}>
                    <img src={un.type === 'matchup' ? un.result === 'win' ? matchup[`${winner}Icon`] : matchup[`${loser}Icon`] : prop_bet} />
                    <div className='game-results'>
                      <div className='title'>{matchup.name}</div>
                      <div className='meta'>Winner: {matchup[winner]}</div>
                      <div className={`result-pts ${un.result}`}>{un.result === 'win' ? '+' : ''}{un.points}</div>
                      {
                        (un.type === 'prop' && un.result === 'win' && underdogBonusTotals[un.matchId]) 
                        ?
                        <div className={`ud-bonus`}>Underdog Bonus: <span className='win bold'>+{underdogBonusTotals[un.matchId]}</span></div>
                        : null
                      }

                    </div>
                  </div>
                )
              })
            }
            <div className='total g-box with-border'>
              Points {totalUnviewed >= 0 ? 'Earned' : 'Lost'}: <span className={totalUnviewed >= 0 ? 'green' : 'red'}>{totalUnviewed >= 0 ? '+' : ''}{totalUnviewed}</span>
            </div>
            <hr />
            <div className='buttons'>
              <button className='g-button' onClick={() => markAsViewed()}>OK</button>
            </div>
          </>
        }
      </Modal>
    </div>
  )
}

export default NewResultsModal